<h2 mat-dialog-title>Additional Guarantor</h2>
<mat-dialog-content class="mat-typography">
  <div class="edit-borrower-property-owner-dialog-content">
    <form [formGroup]="formGroup">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="borrower-entity-guarantor-field">
            <div class="field-label-row mat-caption">
              Borrowing Entity to Appear as Guarantor
              <span
                matTooltip="Required when property is owned by the borrowing entity"
                matTooltipPosition="after"
                class="tooltip-icon mdi mdi-help-circle-outline ml-1"></span>
            </div>
            <yes-no
              title=""
              [formControl]="formControlBorrowerEntityPropertyOwner">
            </yes-no>
          </div>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="isSaving">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    (click)="onSubmit()"
    [disabled]="!formGroup.valid || isSaving">
    @if (isSaving) {
      <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
      Saving...
    } @else {
      Save Changes
    }
  </button>
</mat-dialog-actions>
